<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Medio Com Imagen</h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Imagen</th>
          <th scope="col">Nombre</th>
          <th scope="col">Tipo</th>
          <th scope="col">PagoFechaReg</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pagoimg in datosPaginados" :key="pagoimg.idPagoImg">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(pagoimg.idPagoImg)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(pagoimg.idPagoImg)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <img
              :src="direccionImagen(pagoimg.idPagoImg)"
              :style="estiloImagen"
            />
          </td>
          <td>{{ pagoimg.nombre }}</td>
          <td>{{ pagoimg.tipo }}</td>
          <td>{{ getFormattedDate(pagoimg.pagoFechaReg, "DD/MM/YYYY") }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deletePagoImg(pagoimg.idPagoImg)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPagoImg" class="form-label">IdPagoImg</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idPagoImg"
                      name="idPagoImg"
                      v-model="datoPagoImg.idPagoImg"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Pago -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPago" class="form-label"> Pago</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPago"
                      name="idPago"
                      v-model="datoPagoImg.idPago"
                    >
                      <option
                        v-for="pago in pagos"
                        :value="pago.idPago"
                        :key="pago.idPago"
                      >
                        {{ pago.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Pago -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="imagen" class="form-label">Imagen</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="imagen"
                      name="imagen"
                      v-model="datoPagoImg.imagen"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Imagen</label>
                  </div>
                  <div class="col-10">
                    <img
                      :src="direccionImagen(datoPagoImg.idPagoImg)"
                      :style="estiloImagen"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="imagen" class="form-label">Imagen</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="file"
                      class="form-control"
                      id="imagenCarga"
                      name="imagenCarga"
                      accept="image/*"
                      @change="handleFileUpload"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoPagoImg.nombre"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="tipo" class="form-label">Tipo</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="tipo"
                      name="tipo"
                      v-model="datoPagoImg.tipo"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarPagoImg"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPagoImg"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      pagoimgs: [],
      datoPagoImg: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      pagos: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchPagos();
  },
  methods: {
    async handleFileUpload(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("image", file);
      await api.post("/pagoimgs/" + this.datoPagoImg.idPago,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          // Manejar la respuesta del backend
          console.log("Archivo subido exitosamente" + response);
        })
        .catch((error) => {
          // Manejar errores
          console.error("Error al subir el archivo", error.response.data);
        });
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.pagoimgs.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwpagoimgs/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.pagoimgs = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.pagoimgs.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwpagoimgs").then((response) => {
        this.pagoimgs = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.pagoimgs.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idPago", "imagen", "nombre", "tipo"];
      const requiredFieldsText = ["idPago", "imagen", "nombre", "tipo"];
      return validarForm(this.datoPagoImg, requiredFields, requiredFieldsText);
    },
    async guardarPagoImg() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/pagoimgs",
            this.datoPagoImg
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "PagoImg creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarPagoImg() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/pagoimgs",
            this.datoPagoImg
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PagoImg creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoPagoImg = {};
      this.titulo = "Crear Medio Com Imagen";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idPagoImg) {
      this.modalWindow = true;
      if (idPagoImg != null) {
        api.get("/vwpagoimgs/" + idPagoImg)
          .then((resp) => {
            this.datoPagoImg = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Medio Com Imagen";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idPagoImg) {
      if (idPagoImg != null) {
        this.$router.push("/pagoimgmd/" + idPagoImg);
      }
    },
    async deletePagoImg(idPagoImg) {
      try {
        await api.delete("/pagoimgs/" + idPagoImg
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchPagos() {
      fetch(config.apiBaseUrl + "/pagos")
        .then((response) => response.json())
        .then((data) => {
          this.pagos = data;
        })
        .catch((error) => {
          console.error("Error fetching pagos:", error);
        });
    },
  },
};
</script>
